module.exports = __webpack_public_path__ + "img/Clock_u.e50791ea.svg";